import { Injectable, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { DefaultDraftItem } from '../../models/default-draft-template.model';
import { PlanningDefaultDraftsApiActions } from '../state/planning-default-drafts.actions';
import { planningDefaultDraftsFeature } from '../state/planning-default-drafts.state';

@Injectable()
export class PlanningDefaultDraftsFacadeService {

  constructor(@Inject(Store) private store: Store) {}

  // Selectors
  selectAll(): Observable<DefaultDraftItem[]> {
    return this.store.select(planningDefaultDraftsFeature.selectAll);
  }

  selectCursor(): Observable<string> {
    return this.store.select(planningDefaultDraftsFeature.selectCursor);
  }

  // Actions
  getMany(params?: any): void {
    this.store.dispatch(PlanningDefaultDraftsApiActions.getDefaultDrafts({params}));
  }

  fetchNext(params?: any): void {
    this.store.select(planningDefaultDraftsFeature.selectCursor).pipe(take(1)).subscribe((cursor) => {
      if (cursor) {
        this.store.dispatch(PlanningDefaultDraftsApiActions.getDefaultDrafts({params}));
      }
    });
  }

  updateDraft(id: string, payload: any): void {
    this.store.dispatch(PlanningDefaultDraftsApiActions.updateDefaultDraft({id, payload}));
  }

  renameDraft(id: string, payload: any): void {
    this.store.dispatch(PlanningDefaultDraftsApiActions.renameDefaultDraft({id, payload}));
  }

  deleteDraft(id: string): void {
    this.store.dispatch(PlanningDefaultDraftsApiActions.deleteDefaultDraft({id}));
  }

  clearStore(): void {
    this.store.dispatch(PlanningDefaultDraftsApiActions.clearStore({force: true}));
  }
}
